<template>
  <div>
    <Navbar v-if="this.$route.name == 'gdqshortsettings'"/>
    <Breadcrumb v-if="this.$route.name == 'gdqshortsettings'" />     
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="money-bill"
            />Pricing
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
            <b-form-group 
              label-cols="4"
              label="VAT rate (%)"
              class="col-12"
            >
              <b-form-input  
                id="gdqshort_vat" 
                class="form-control col-7"
                v-model="gdqshort_vat"
                v-on:change="savepref('gdqshort_vat',gdqshort_vat)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group 
              label-cols="4"
              label="GDQ Short Report price per survey"
              class="col-12"
            >
              <b-form-input  
                id="gdqshortreport_price" 
                class="form-control col-7"
                v-model="gdqshortreport_price"
                v-on:change="savepref('gdqshortreport_price',gdqshortreport_price)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"            
              name="envelope"
            />Invitations
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <DefaultGDQShortMailTexts />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="tasks"
            />GDQ Short Questions
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_gdqshortquestions" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="print"
            />Report Texts
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_shortreporttexts" />
        </b-card>
      </b-tab>       
    </b-tabs>
  </div>
</template>
<script>

import Maintenance from './Maintenance';
import DefaultGDQShortMailTexts from './DefaultGDQShortMailTexts';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'GDQShortSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Maintenance,
    DefaultGDQShortMailTexts,
    Navbar,
    Breadcrumb,
  },
  data: function() {
    return {
      gdqshortreport_price: 0,
      gdqshort_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqshortreport_price' })
      .then((resp) => {
        this.gdqshortreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'gdqshort_vat' })
        .then((resp) => {
          this.gdqshort_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
